import React, { useState, useEffect, fallbackCopy } from 'react';
import { request, GET, PATCH } from '../../api/ApiAdapter';
import { Col, Container, Row, Button, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import TopAdminBar from '../../components/TopAdminBar';
import Footer from '../../components/Footer';
import { useHistory } from 'react-router-dom';
import { HiRefresh } from 'react-icons/hi';
import { DateRangePicker } from 'react-date-range';
import EditContactDialog from './EditContactDialog';
import moment from 'moment';
import './Contacts.css';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

const Contacts = () => {
    const [contacts, setContacts] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [dateRange, setDateRange] = useState([
        {
            startDate: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), // default startDate 7 days before endDate
            endDate: new Date(),
            key: 'selection'
        }
    ]);
    const [showDateRangePicker, setShowDateRangePicker] = useState(false);
    const history = useHistory();
    const contactTypeOptions = ["New_Lead", "Contacted", "Interested", "Scheduled", "Follow_Up", "Not_Interested", "Employee"];

    const loadContacts = async () => {
        try {
            const startDate = dateRange[0].startDate.toISOString();
            const endDate = dateRange[0].endDate.toISOString();
            let result = await request(`contacts?startDate=${startDate}&endDate=${endDate}`, GET);
            if (!result.error) {
                setContacts(result);
            } else {
                console.log('Error');
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push('/page/login');
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleEditClick = (contact) => {
        setSelectedContact(contact);
        setShowDialog(true);
    };

    const handleSave = async (id, note) => {
        try {
            let result = await request('contacts/note', PATCH, {
                id: id,
                note: note
            });
            if (!result.error) {
                window.location.reload(false);
                toast.success('Contact updated successfully!');
            } else {
                toast.error('Failed to update contact!');
            }
        } catch (e) {
            console.log(e);
            toast.error('An error occurred while updating contact!');
        }
    };

    const handleContactTypeSave = async (id, type) => {
        try {
            let result = await request('contacts/type', PATCH, {
                id: id,
                type: type
            });
            if (!result.error) {
                window.location.reload(false);
                toast.success('Contact updated successfully!');
            } else {
                toast.error('Failed to update contact!');
            }
        } catch (e) {
            console.log(e);
            toast.error('An error occurred while updating contact!');
        }
    };

    const selectOnTable = (data) => {
        const selectedText = String(data);
        if (selectedText) {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard
              .writeText(selectedText)
              .then(() => {
                toast.success('Copied');
              })
              .catch(() => {
                fallbackCopy(selectedText);
              });
          } else {
            fallbackCopy(selectedText);
          }
        }
      };

    const refreshContacts = () => {
        loadContacts();
    };

    useEffect(() => {
        loadContacts();
    }, [dateRange]);

    const formatDateRange = () => {
        const startDate = moment(dateRange[0].startDate).format('YYYY-MM-DD');
        const endDate = moment(dateRange[0].endDate).format('YYYY-MM-DD');
        return `${startDate} to ${endDate}`;
    };

    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="bg-white h-screen">
                <TopAdminBar />
                <div className="ml-64 top-1 mt-3 left-0 flex items-center overflow-auto">
                    <div className="screenSize">
                        <div>
                            <b className="text-lg ml-8 mt-20">Contacts</b>
                        </div>
                        <Container className="mr-10 mt-6">
                            <Row>
                                <Col xs={7}></Col>
                                <Col xs={4} className="d-flex justify-content-end">
                                    <button onClick={() => setShowDateRangePicker(true)} className="text-sm font-bold bg-primary-light-blue rounded-xl p-2">
                                        {`Filter by Date (${formatDateRange()})`}
                                    </button>
                                </Col>
                                <Col xs={1}>
                                    <button
                                        onClick={refreshContacts}
                                        className="lg:flex items-center justify-center text-2xl bg-primary-light-blue rounded-xl p-2"
                                    >
                                        <HiRefresh />
                                    </button>
                                </Col>
                            </Row>
                        </Container>
                        <div className="container mt-4 px-10 mb-16">
                            <div className="vertical_Table_Scroll">
                                <table className="table table-bordered border-info shadow">
                                    <thead>
                                        <tr className="header">
                                            <th style={{ width: '1%' }}>#</th>
                                            <th style={{ width: '10%' }}>PHONE NUMBER</th>
                                            <th style={{ width: '25%' }}>VEHICLES</th>
                                            <th style={{ width: '6%' }}>CONTACT TYPE</th>
                                            <th style={{ width: '15%' }}>DATE</th>
                                            <th style={{ width: '10%' }}>TO BE CONTACTED</th>
                                            <th style={{ width: '33%' }}>NOTE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contacts.length === 0 ? (
                                            <tr align="center">
                                                <td colSpan="8">No Record Found</td>
                                            </tr>
                                        ) : (
                                            contacts.map((contact, index) => (
                                                <tr key={contact.id} className={`${contact.contactYes ? ' bg-yellow-300' : ''}`}>
                                                    <td style={{backgroundColor: 'initial'}}>{index + 1}</td>
                                                    <td
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: 'initial',
                                                          }}
                                                        onClick={({target}) => selectOnTable(target.textContent)}
                                                    >
                                                    {contact.phoneNumber}
                                                    </td>
                                                    <td style={{backgroundColor: 'initial'}}>
                                                        {contact.vehicles && contact.vehicles.length > 0 ? (
                                                        contact.vehicles.map((vehicle, index) => (
                                                            <span key={index}>
                                                            {vehicle}
                                                            <br />
                                                            </span>
                                                        ))
                                                        ) : (
                                                        "N/A"
                                                        )}
                                                    </td>
                                                    <td style={{backgroundColor: 'initial'}}>
                                                        <select
                                                            value={contact.contactType || ""}
                                                            onChange={(e) => handleContactTypeSave(contact.id, e.target.value)}
                                                        >
                                                            <option value="">Select Contact Type</option>
                                                            {contactTypeOptions.map((option, i) => (
                                                                <option key={i} value={option}>
                                                                    {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td style={{backgroundColor: 'initial'}}>{moment(contact.updatedTime).format('YYYY/MM/DD HH:mm:ss')}</td>
                                                    <td style={{backgroundColor: 'initial'}}>{contact.contactYes != null ? contact.contactYes ? "Yes" : "" : ""}</td>
                                                    <td
                                                        style={{ cursor: 'pointer', width: '20px', backgroundColor: 'initial'}}
                                                        onClick={() => handleEditClick(contact)}
                                                    >
                                                        {contact.note || "N/A"}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
            <Modal
                show={showDateRangePicker}
                onHide={() => setShowDateRangePicker(false)}
                centered
                dialogClassName="date-range-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Select Date Range</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DateRangePicker
                    ranges={dateRange}
                    onChange={(item) => setDateRange([item.selection])}
                    maxDate={new Date()} // Disable future dates
                    />
                </Modal.Body>
            </Modal>
            {selectedContact && (
                <EditContactDialog
                    show={showDialog}
                    handleClose={() => [setSelectedContact(null), setShowDialog(false)]}
                    contact={selectedContact}
                    handleSave={handleSave}
                />
            )}
        </>
    );
};

export default Contacts;
